
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class TableSearchField extends Vue {
  @Prop(String)
  placeholder!: string;

  @Prop(String)
  store!: string;

  debounce: ReturnType<typeof setTimeout> | null = null;

  created() {
    this.$store.commit(`${this.store}/setQuery`, '');
  }

  debounceSearch(query: string, delay = 400) {
    if (this.debounce !== null) {
      clearTimeout(this.debounce);
    }
    this.debounce = setTimeout(() => this.search(query), delay);
  }

  search(query: string) {
    this.$store.dispatch(`${this.store}/search`, query);
  }
}
